// extracted by mini-css-extract-plugin
export default {"boardWrapper":"BoardTabs_boardWrapper__nvQRy","writeBtn":"BoardTabs_writeBtn__k8COw"};